import i18n from "i18n-js"
import { useState } from "react"
import patients from "../../../../../services/patients"
import { downloadPdfFromBlob } from "../../../../../utils/tools"
import { downloadsEnum } from "../constants/enums"

export const usePatientReports = () => {
    const [showSnackBar, setShowSnackBar] = useState(false)
    const [snackBar, setSnackBar] = useState({})
    const [loadings, setLoadings] = useState({
        [downloadsEnum.MEDICAL]: false,
        [downloadsEnum.PATIENT]: false
    })

    const handleSnackBar = () => {
        setShowSnackBar(false)
    }

    const getPatientReport = async ({ patientId }) => {
        setLoadings(prev => ({ ...prev, [downloadsEnum.PATIENT]: true }))

        try {
            const response = await patients.getPatientReports({ patientId })
            downloadPdfFromBlob(response.data, `${i18n.t('general.patient_report')}.pdf`)
            setSnackBar({
                text: i18n.t('general.snackbarPatient.success'),
                severity: 'success',
            })
        }
        catch (e) {
            setSnackBar({
                text: i18n.t('general.snackbarPatient.error'),
                severity: 'warning',
            })
        }
        finally {
            setShowSnackBar(true)
            setLoadings(prev => ({ ...prev, [downloadsEnum.PATIENT]: false }))
        }
    }

    const getMedicalReport = async ({ patientId }) => {
        setLoadings(prev => ({ ...prev, [downloadsEnum.MEDICAL]: true }))
        try {
            const response = await patients.getPatientReports({ reportType: 2, patientId })
            downloadPdfFromBlob(response.data, `${i18n.t('general.doctor_report')}.pdf`)

            setSnackBar({
                text: i18n.t('general.snackbarDoctor.success'),
                severity: 'success',
            })
        }
        catch (e) {
            setSnackBar({
                text: i18n.t('general.snackbarDoctor.error'),
                severity: 'warning',
            })
        }
        finally {
            setShowSnackBar(true)
            setLoadings(prev => ({ ...prev, [downloadsEnum.MEDICAL]: false }))
        }
    }

    return {
        loadings,
        snackBar,
        showSnackBar,
        setShowSnackBar,
        handleSnackBar,
        setSnackBar,
        getPatientReport,
        getMedicalReport
    }
}